module.exports = __webpack_public_path__ + "static/media/Congoleum.976af838.svg";